import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  // descripcion: z.string().min(1, 'La descripción es obligatoria'),
  /* multiImagenes: z.array(z.object({
    nombre: z.string()
  })).nonempty('Debes tener al menos una imagen') */
});